import styled from "styled-components";

export const StyledHeader = styled.header`
  border-bottom: 1px solid ${({ theme }) => theme.neutral100};
  padding: 16px 24px;
  justify-content: space-between;
  display: flex;
  align-items: center;
`;
